// Azzurro vocabulary expansion — FOOD theme (net-new cards).
//
// Extends the `food` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ italian, english, emoji, part_of_speech, gender, example_it, example_en ]

export const VOCAB_FOOD = [
  {
    theme: "food", tier: "A1", rows: [
      ["la mela", "apple", "🍎", "noun", "f", "Mangio una mela ogni giorno.", "I eat an apple every day."],
      ["il pomodoro", "tomato", "🍅", "noun", "m", "Il pomodoro è maturo.", "The tomato is ripe."],
      ["il pollo", "chicken", "🍗", "noun", "m", "A cena mangiamo pollo con riso.", "We're having chicken with rice for dinner."],
      ["il riso", "rice", "🍚", "noun", "m", "Il riso è pronto.", "The rice is ready."],
      ["la zuppa", "soup", "🍲", "noun", "f", "La zuppa è molto calda.", "The soup is very hot."],
      ["il succo", "juice", "🧃", "noun", "m", "Voglio un succo d'arancia.", "I want an orange juice."],
      ["il burro", "butter", "🧈", "noun", "m", "Metti il burro sul pane.", "Put butter on the bread."],
      ["l'arancia", "orange", "🍊", "noun", "f", "L'arancia è dolce.", "The orange is sweet."],
      ["la patata", "potato", "🥔", "noun", "f", "Le patate sono fritte.", "The potatoes are fried."],
      ["la banana", "banana", "🍌", "noun", "f", "La banana è ancora verde.", "The banana is still green."],
    ],
  },
  {
    theme: "food", tier: "A2", rows: [
      ["la farina", "flour", "🌾", "noun", "f", "Mi serve la farina per il pan di Spagna.", "I need flour for the sponge cake."],
      ["il cucchiaino", "teaspoon", "🥄", "noun", "m", "Aggiungi un cucchiaino di sale.", "Add a teaspoon of salt."],
      ["la ciotola", "bowl", "🥣", "noun", "f", "Sbatti le uova in una ciotola.", "Beat the eggs in a bowl."],
      ["la padella", "frying pan", "🍳", "noun", "f", "La padella è molto calda.", "The frying pan is very hot."],
      ["la pentola", "pot", "🍲", "noun", "f", "Metti la pasta nella pentola.", "Put the pasta in the pot."],
      ["arrostire", "to roast", "🔥", "verb", "", "Arrostiamo le verdure al forno.", "We're going to roast vegetables in the oven."],
      ["tritare", "to chop", "🔪", "verb", "", "Trita la cipolla molto finemente.", "Chop the onion very finely."],
      ["la fetta", "slice (round)", "🍋", "noun", "f", "Taglia il limone a fette.", "Cut the lemon into slices."],
      ["crudo", "raw", "🥩", "adjective", "", "Il pollo è ancora crudo.", "The chicken is still raw."],
      ["maturo", "ripe", "🥑", "adjective", "", "L'avocado è ormai maturo.", "The avocado is ripe now."],
    ],
  },
  {
    theme: "food", tier: "B1", rows: [
      ["il dopopranzo", "after-meal table talk", "☕", "noun", "m", "Il dopopranzo è durato due ore.", "The after-lunch chat lasted two hours."],
      ["l'aperitivo", "appetizer / pre-meal drink", "🫒", "noun", "m", "Prendiamo un aperitivo prima di pranzo.", "We had an appetizer before lunch."],
      ["il contorno", "side dish", "🥗", "noun", "m", "Il piatto ha un contorno di verdure.", "The dish comes with a vegetable side."],
      ["condire", "to dress / season", "🫗", "verb", "", "Condisci l'insalata con olio e aceto.", "Dress the salad with oil and vinegar."],
      ["stucchevole", "sickly sweet", "🍯", "adjective", "", "Questo dolce è troppo stucchevole.", "This dessert is too sickly sweet."],
      ["il commensale", "dinner guest / diner", "🍽️", "noun", "m", "Eravamo otto commensali a tavola.", "There were eight of us at the table."],
      ["scolare", "to drain", "💧", "verb", "", "Scola la pasta prima di servirla.", "Drain the pasta before serving it."],
      ["a fuoco lento", "on a low heat", "🔥", "phrase", "", "Cuoci la salsa a fuoco lento.", "Cook the sauce on a low heat."],
      ["la dieta", "diet", "🥦", "noun", "f", "È a dieta da gennaio.", "He's been on a diet since January."],
      ["il fornello", "stove / burner", "🍳", "noun", "m", "Ho quattro fornelli in cucina.", "I have four burners in the kitchen."],
    ],
  },
];
